import * as deviceActionsImport from './devices'
import * as trackActionsImport from './tracks'
import * as sessionActionsImport from './sessions'
import * as mediaActionsImport from './media'
import * as miscActionsImport from './misc'

// Apparently the following doesn't work:
//      export * as newName from './place';
// So import everything from each file, then re-export.
export const deviceActions = deviceActionsImport
export const trackActions = trackActionsImport
export const sessionActions = sessionActionsImport
export const mediaActions = mediaActionsImport
export const miscActions = miscActionsImport
